<!-- Lucide "app-window-mac", drawn on a 24 grid -->
<template>
    <g
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
    >
        <rect
            x="2"
            y="4"
            width="20"
            height="16"
            rx="2"
        />
        <path d="M6 8h.01" />
        <path d="M10 8h.01" />
        <path d="M14 8h.01" />
    </g>
</template>
